module.exports = __webpack_public_path__ + "img/mask-star.436dda19.svg";